import { ReactNode } from "react";
import { useStyle } from "./style";
import { getRowClassName } from "./utils";
import { Grid } from "@mui/material";
import { Check } from "@mui/icons-material";

interface IParams {
    isSelected: boolean;
    rowAriaLabel: string;
    children: ReactNode;
    index: number;
    dataLength: number;
    isFlagged?: boolean;
    onSelect(): void;
}

export const SelectableRow = (props: IParams) => {
    const { isSelected, rowAriaLabel, children, index, dataLength, isFlagged, onSelect } = props;
    const { classes } = useStyle({ isSelected, isFlagged });

    return (
        <Grid className={getRowClassName(index, dataLength, classes)} container>
            <Grid aria-label={rowAriaLabel} className={classes.rowContentContainer} item>
                <Grid container data-testid="selectable-row" onClick={onSelect}>
                    {isSelected && (
                        <div className={classes.selectedRowCheckContainer}>
                            <Check aria-label="checkmark" className={classes.selectedRowCheck} fontSize="small" />
                        </div>
                    )}
                    {children}
                </Grid>
            </Grid>
        </Grid>
    );
};
